import MobileBottomPanel from '@ui/MobileBottomPanel/component'
import type { MobileBottomPanelType } from '@ui/MobileBottomPanel/component'

export default (el: HTMLElement): void => {
  const mobileBottomPanelEl = el.querySelector<HTMLElement>('.search-mobile-recap-panel')

  if (!mobileBottomPanelEl) {
    return
  }

  let mobileBottomPanel: MobileBottomPanelType | null = null

  el.addEventListener('click', () => {
    if (mobileBottomPanel === null) {
      mobileBottomPanel = MobileBottomPanel(mobileBottomPanelEl)
    }

    mobileBottomPanel.toggle()
  })
}
